export const KIXIE_COLORS = {
  dnd: '#E7505A',
  onCall: '#26C281',
  loggedOut: '#DDDDDD',
  available: '#0098C7',
};

export const ACCESS_TOKEN_COOKIE_EXPIRE_MS = 1000 * 60 * 30; // 30 minutes
export const ACCESS_TOKEN = 'accessToken';
// export const ACCESS_TOKEN_EXPIRE_TIMESTAMP = 'accessTokenExpireTimestamp';
// export const ACCESS_TOKEN_EXPIRE_DEBUG = 'accessTokenExpireDebug';
export const REFRESH_TOKEN = 'refreshToken';
export const LAST_USER_ID = 'lastUserId';
